import { makeStyles, Theme } from '@material-ui/core/styles';

import { mainBackground, black, iron, } from '../abstract/variables';

export const makeCartShopStyles = makeStyles((theme: Theme) => ({
    container: {
        [theme.breakpoints.up('md')]: {
            width: 500,
        },

        background: mainBackground,
    },
}), { index: 1, });

export const makeCartShopItemTextStyles = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
}, { index: 1, });

export const makeCartShopButtonRemoveItemStyles = makeStyles({
    textSizeSmall: {
        padding: 0,
    },
}, { index: 1, });

export const makeCartShopHeaderStyles = makeStyles({
    root: {
        background: iron,
        color: black,
    },
}, { index: 1, });
